var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashBinWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40540",
    "data-name": "Group 40540",
    transform: "translate(12422 17260)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15361",
    "data-name": "Rectangle 15361",
    width: 16,
    height: 16,
    transform: "translate(-12422 -17260)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bin_x2F_delete_layer_1_",
    transform: "translate(-12475.932 -17279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36968",
    "data-name": "Path 36968",
    d: "M67.864,100a1.186,1.186,0,0,0-1.186,1.186v9.254a1.186,1.186,0,0,1-1.186,1.186H58.373a1.186,1.186,0,0,1-1.186-1.186v-9.254A1.186,1.186,0,0,0,56,100",
    transform: "translate(0 -77.627)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2718",
    "data-name": "Line 2718",
    x2: 11.864,
    transform: "translate(56 22.373)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2719",
    "data-name": "Line 2719",
    y2: 6.881,
    transform: "translate(59.559 24.746)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2720",
    "data-name": "Line 2720",
    y2: 6.881,
    transform: "translate(61.932 24.746)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2721",
    "data-name": "Line 2721",
    y2: 6.881,
    transform: "translate(64.305 24.746)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36969",
    "data-name": "Path 36969",
    d: "M180.746,22.373H176V21.186A1.186,1.186,0,0,1,177.186,20h2.373a1.186,1.186,0,0,1,1.186,1.186Z",
    transform: "translate(-116.441)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBinWhite);
export default __webpack_public_path__ + "static/media/trash-bin-white.b9d5d29b68abd57dfd526c421124e1a5.svg";
export { ForwardRef as ReactComponent };